// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IExamForm } from '~/utils/mockData/common';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      studentId: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      studentName: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      courseId: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      courseName: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      moduleId: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      moduleName: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      status: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      value: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      pointValue: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      credits: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      note: yup.string().trim().optional(),
    })
    .required();
};

export const defaultValuesForm: IExamForm = {
  studentId: '',
  studentName: '',
  courseId: '',
  courseName: '',
  moduleId: '',
  moduleName: '',
  status: '',
  pointValue: '',
  value: '',
  credits: '',
  note: '',
};
